import type { HoldCleaningImage } from "../models/hold-cleaning.models";

export type ImageCategoryFilter = "ALL" | NonNullable<HoldCleaningImage["category"]>;
export const IMAGE_CATEGORY_LABELS: Record<ImageCategoryFilter, string> = {
  ALL: "All images",
  HOLD_PHOTO: "Hold photos",
  EQUIPMENT_PHOTO: "Equipment photos",
  DOCUMENT: "Documents and diagrams",
  OTHER: "Other images",
  UNCLASSIFIED: "Not categorized",
};
export const filterImageCategory = (images: HoldCleaningImage[], category: ImageCategoryFilter) =>
  category === "ALL" ? images : images.filter((image) => (image.category ?? "UNCLASSIFIED") === category);
